import { HeroImage, StaticPageLoadingPlaceholder, useAnalyticsErrorPageTracker } from '@cp-shared-19/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React from 'react';
import { useLogin } from '../../../auth/useLogin';
import { useForbiddenErrorPage } from './useForbiddenErrorPage';

export const ForbiddenErrorPage: React.FC = () => {
    const { cmsContent: forbiddenErrorPage, isLoading, loadingError } = useForbiddenErrorPage();

    const HeroImageWithHandlers = withLoadingAndNoConnectionHandler(HeroImage);

    useAnalyticsErrorPageTracker('accessDeniedError', !!forbiddenErrorPage);

    return (
        <HeroImageWithHandlers
            isLoading={isLoading}
            hasError={!!loadingError}
            pretitle={forbiddenErrorPage?.pretitle}
            title={forbiddenErrorPage?.title || ''}
            subTitle={forbiddenErrorPage?.subTitle}
            buttonText={forbiddenErrorPage?.buttonText}
            clickHandler={useLogin()}
            loadingPlaceholder={<StaticPageLoadingPlaceholder withHeroTeaser={false} />}
        />
    );
};
